export const ToothIcon = ({ className = "h-6 w-6" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M12 3c-2.5 0-4.5 1-6 2.5C4.5 7 4 8.5 4 10c0 2 .6 4 1.2 6.3.5 2 1 4.2 1.8 5.4.4.6 1 1 1.6.9.8-.1 1.1-1 1.3-1.8.3-1.4.5-3.4.8-4.8.2-.9.6-1.5 1.3-1.5s1.1.6 1.3 1.5c.3 1.4.5 3.4.8 4.8.2.8.5 1.7 1.3 1.8.6.1 1.2-.3 1.6-.9.8-1.2 1.3-3.4 1.8-5.4C19.4 14 20 12 20 10c0-1.5-.5-3-2-4.5C16.5 4 14.5 3 12 3z" />
  </svg>
);
